<div
  #tooltipContentElement
  class="tooltip"
  [style.left.px]="x"
  [style.top.px]="y"
  [innerHTML]="tooltipContent"
>
</div>
